/**
 * 用户查询接口：按公开邀请 ID（CM-XXXXXX）锁定用户。
 *
 * 用途：队长在队伍页输入对方的邀请 ID → 先查出来确认是不是本人 → 再发邀请，
 * 避免「只能从候选人池里复制 UUID」这个找不到人的死结。
 */
import { api } from './client.js';
import type { UserLookupDto } from './types.js';

export const usersApi = {
  /** GET /users/lookup?code=CM-XXXXXX → 脱敏用户信息（不含邮箱） */
  lookup: (code: string): Promise<UserLookupDto> =>
    api.get<UserLookupDto>(`/users/lookup?code=${encodeURIComponent(code)}`),
};
